var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg01"},[_c('Head',{attrs:{"title":"个人资料"}}),_c('wv-group',[_c('wv-cell',{attrs:{"title":"昵称","value":_vm.name,"is-link":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }